import {EventMap} from '@mintdata/mint-kit/api/events/EventMap';
import {EventSpec} from '@mintdata/mint-kit/api/events/EventSpec';

export class EventUtils
{
    private static readonly EVENT_MAP_KEY = '___eventMap';

    public static getOrCreateEventMap(target:any, isAttached:boolean = false):EventMap
    {
        const mapKey:string = EventUtils.EVENT_MAP_KEY;
        let eventMap = target[mapKey];

        if( !eventMap )
            eventMap = target[mapKey] = new EventMap();

        return eventMap;
    }

    public static getEventMap(target:any):EventMap
    {
        return target[EventUtils.EVENT_MAP_KEY];
    }

    public static getEvents(target:any):Array<EventSpec>
    {
        const eventMap:EventMap = EventUtils.getEventMap(target);

        if( eventMap )
            return eventMap.getEvents();

        return [];
    }

    public static initEvents(component:React.Component<any, any>):void
    {
        let componentCtor = component.constructor;
        let eventSpecs:EventSpec[] = EventUtils.getEvents(componentCtor);

        for( var i = 0; i < eventSpecs.length; i++ )
        {
            var eventSpec = eventSpecs[i];
            component.context[eventSpec.eventPropertyName];
        }

    }

}
